const preventAddToCart = {
  dummyBtn: document.getElementById("dummyAddToCart") as HTMLElement | undefined,
  btn: document.getElementById("addToCart") as HTMLElement | undefined,
  qty: Array.from(document.querySelectorAll(".jsQty")) as HTMLInputElement[],
  assembleMinQty: document.getElementById("assembleMinQty") as HTMLInputElement | undefined,
  minQty: 1,
  init() {
    this.addEvent()
    this.setMin()
    
  },

  addEvent() {
    this.qty.forEach((item) => {
      if(item.max === item.min){
        item.disabled = true
        this.qty = this.qty.filter(el => el !== item)
      }
      item.addEventListener("change", () => {
        this.setBtns()
      })
    })
  },
  setMin(){
   
    if(this.assembleMinQty && this.assembleMinQty.value){
      this.minQty = +this.assembleMinQty.value
    }
    if( this.dummyBtn){
      this.dummyBtn.classList.remove("d-none")
      this.dummyBtn.innerText = `Choose ${this.minQty} Item(s)`
    }
  },
  setBtns() {
    let sum = 0
    this.qty.forEach((item) => {   
      if (+item.value) {
        sum = sum + +item.value
      }
    })    
    if (sum >= this.minQty) {
      this.btn?.classList.remove("d-none")
      this.dummyBtn?.classList.add("d-none")
    } else {
      this.btn?.classList.add("d-none")
      if( this.dummyBtn){
        this.dummyBtn.classList.remove("d-none")
        this.dummyBtn.innerText = `Choose ${this.minQty - sum} More Item(s)`
      }
   

    }  
  },
}

export default preventAddToCart
